import type { Options } from "canvas-confetti";

type Fire = (options?: Options) => void;

let loader: Promise<Fire> | null = null;

const load = () => {
  if (!loader) {
    loader = import("canvas-confetti").then(
      (m) => ((m as unknown as { default?: Fire }).default ?? (m as unknown as Fire)) as Fire,
    );
  }
  return loader;
};

/**
 * Fires confetti, loading the library on first use so it stays out of the
 * initial JavaScript bundle.
 */
export const confetti: Fire = (options) => {
  if (typeof window === "undefined") return;
  void load().then((fire) => {
    fire(options);
  });
};

export default confetti;
